<div
  *ngIf="type"
  class="divider"
  [ngClass]="[
    padding === 'small'
      ? 'small'
      : padding === 'medium'
      ? 'medium'
      : padding === 'large'
      ? 'large'
      : 'ultra',
    'line'
  ]"
></div>

<div
  *ngIf="!type"
  class="divider"
  [ngClass]="
    padding === 'small'
      ? 'small'
      : padding === 'medium'
      ? 'medium'
      : padding === 'large'
      ? 'large'
      : 'ultra'
  "
></div>
